import { BasicEvent } from "./BasicEvent";

export class ArbetsorderHandelssortimentDeletedEventMessage extends BasicEvent {
    arbetsorderId: number;
    arbetsorderHandelssortimentId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderHandelssortimentDeletedEventMessage";
    constructor($type: string) {
        super($type);
    }
}
